var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarpng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "translate(0.519531 0.630005)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1792_259",
    transform: "scale(0.04)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1792_259",
    width: 25,
    height: 25,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAMlQTFRFIkOSIUKRLEyXPVqfLUyXrLjWMU+ZTGam6Ov0UWupjZ7H////l6fL6Ovz8vT5JkeUVW+rXHSuaoC1dIm6usTdvcfeS2am6ez06u31RmGjucPc9/j7+Pn8v8nfJ0eUhZfD+vv9/f3+jp7HKEiUI0SS5+vz4OXwYXmxLEuW9fb6s77aeo29lqbLU22qkqLJdYm6K0qWydHk/f7+coe5z9bnLk2YSWSl7/L3pbPTm6rO8fP4S2WmcYa5gpXBfI++eIy8dou7O1ieOVed6YxsXgAAAKlJREFUeJxjYGDEDpgYaCfDjEuGhZUNhww7BycOGS5uHhwyvNx8/FhlBLi5uQXRZISEQUAEKCMKZgnxw2TExLmRgYQAwjRJKWm4uIysGLI9cvIKUAlFJWVUF6gIqoIl1NRV0N2moQmS0NLAdLU2UFxTR1dPH13GwJDbyNCYVYbbxBRNxsyc28KUUcOS28oaTcZGwRZM22nao8qoODhCzXeyV8EMURRAZRkA0k8PtvmQYnIAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarpng);
export default __webpack_public_path__ + "static/media/star.png.a207233ecb4a4ef774318b81c4b2d647.svg";
export { ForwardRef as ReactComponent };